import React, { useState, useEffect } from 'react';
import './InstallPrompt.css';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  // Check if user has previously dismissed the prompt
  const hasUserDismissed = localStorage.getItem('pwa-install-dismissed') === 'true';

  useEffect(() => {
    // Listen for the beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later
      setDeferredPrompt(e);
      // Show the install prompt only if user hasn't dismissed it
      if (!hasUserDismissed) {
        setShowInstallPrompt(true);
      }
    };

    // Listen for the appinstalled event
    const handleAppInstalled = () => {
      console.log('PWA was installed');
      setShowInstallPrompt(false);
      setDeferredPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, [hasUserDismissed]);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === 'accepted') {
      console.log('User accepted the install prompt');
    } else {
      console.log('User dismissed the install prompt');
    }

    // Clear the deferredPrompt
    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const handleDismiss = () => {
    setShowInstallPrompt(false);
  };

  const handleNever = () => {
    // Store user preference to never show the prompt again
    localStorage.setItem('pwa-install-dismissed', 'true');
    setShowInstallPrompt(false);
  };

  if (!showInstallPrompt) return null;

  return (
    <div className="install-prompt">
      <div className="install-prompt-content">
        <div className="install-prompt-icon">📱</div>
        <div className="install-prompt-text">
          <h3>Install Nicole Photos</h3>
          <p>Add this app to your home screen for quick access</p>
        </div>
        <div className="install-prompt-buttons">
          <button 
            className="install-prompt-btn install-prompt-btn-primary"
            onClick={handleInstallClick}
          >
            Install
          </button>
          <button 
            className="install-prompt-btn install-prompt-btn-secondary"
            onClick={handleDismiss}
          >
            Not Now
          </button>
          <button 
            className="install-prompt-btn install-prompt-btn-never"
            onClick={handleNever}
          >
            Never
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPrompt;
